<template>
  <div>
    <feather-icon icon="FileIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="showSessionAttendees()" />

<vs-popup
      class="holamundo"
      title="title"
      :active.sync="popupAttendees"
    >
  <div class="flex flex-wrap items-center">
    <div class="flex-grow">
      <vs-table :data="GroupAttendeeList">
              <template slot="thead">
                <vs-th>Group Name</vs-th>
                <vs-th>Attendee Count</vs-th>                
              </template>

              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].Name">{{data[indextr].Name}}</vs-td>
                  <vs-td :data="data[indextr].ColorCode">{{data[indextr].ColorCode}}</vs-td>
                </vs-tr>
              </template>
            </vs-table>          
    </div>
  </div>
</vs-popup>
</div>
</template>
<script>
export default {
  name: 'CellAttendees',
  data() {
  	return {
  		title: "Session Group Attendees",
  		popupAttendees: false,
  		GroupAttendeeList: []
  	}
  },
  methods: {
  	showSessionAttendees: function(){
  		console.log(this.params.session)
  	}
  }
}
</script>
